<template>
    <a :link="obj.url ? obj.url : 'javascript:void(0);'" class='supad advlink' :pid="obj.id" @click.stop="go" v-if="isShow">
        <img class="pic" :src="obj.pic">
        <span class="close" @click.stop="onClose"></span>
    </a>
</template>
<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';

const obj = ref({
    url: '',
    id: '',
    pic: '',
});

const isShow = ref(false);

const go = () => {
    axios.get(import.meta.env.VITE_SECOND_BASE_API + '/oms/center/api/banner/click', {
        params: {
            id: obj.value.id,
            tenantId: '2287838788945248256',
        }
    }).finally(() => {
        location.href = obj.value.url;
    });
}

const onClose = () => {
    localStorage.setItem('hideSupAd', 'true');
    isShow.value = false;
}

const getData = async () => {
    if (!localStorage.getItem('hideSupAd')) {
        const res = await axios.get(import.meta.env.VITE_SECOND_BASE_API + '/oms/center/api/banner/getBannerList', {
            params: {
                code: 'all_float',
                type: 1,
            }
        });
        if (res?.data?.code == 200 && res?.data?.data?.all_float) {
            const data = res?.data?.data?.all_float[0];
            if (data) {
                obj.value = {
                    url: data.url,
                    id: data.id,
                    pic: data.pic,
                }
                isShow.value = true;
            }
        }
    }
}

onMounted(() => {
    getData();
})
</script>
<style lang="scss" scoped>
.supad {
    position: fixed;
    width: 133px;
    top: 206px;
    left: 10px;
    z-index: 100;
    cursor: pointer;
}

.supad .pic {
    width: 100%;
    display: block;
}

.supad .close {
    width: 14px;
    height: 14px;
    display: block;
    background: url('../../assets/svg/close.svg') no-repeat 0 0;
    position: absolute;
    top: -18px;
    right: -2px;
    cursor: pointer;
}
</style>